<lib-nav-menu-ionic [menuItems]="menuItems"></lib-nav-menu-ionic>
